
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { RevSkeleton } from '@ds/components/Skeleton'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { STATUSES } from '../RecommendationBundle.constants'

import translations from './BundleSmallToModalButton.translations'

export default {
  components: { IconChevronRight, RevList, RevListItem, RevSkeleton },
  props: {
    totalPrice: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    isFetching() {
      return this.status === STATUSES.FETCHING
    },
  },
}
